export default __webpack_public_path__ + "static/media/by-nc-nd.a7359790.svg";